type LoadingPhase = "exploring" | "evaluating" | "awaiting_track";

type Props = {
  phase: LoadingPhase;
};

export default function LoadingStatusGlance({ phase }: Props) {
  return (
    <section className="dashboard-section">
      <div className="dashboard-section-body">
        <div className="mb-4 flex flex-wrap items-center gap-3">
          <span className="rounded-md bg-primary-50 px-3 py-1 text-sm font-semibold text-primary">
            {badgeLabel(phase)}
          </span>
        </div>

        <p className="mb-6 text-lg leading-relaxed text-gray-800">{summaryCopy(phase)}</p>
        <div className="h-4 w-48 animate-pulse rounded bg-gray-200" />
      </div>
    </section>
  );
}

function badgeLabel(phase: LoadingPhase) {
  if (phase === "exploring") {
    return "Exploring";
  }
  if (phase === "awaiting_track") {
    return "Choose pages";
  }
  return "Evaluating";
}

function summaryCopy(phase: LoadingPhase) {
  if (phase === "exploring") {
    return "We are mapping your website. Findings will appear once evaluation starts.";
  }
  if (phase === "awaiting_track") {
    return "Pages are mapped. Choose which ones we'll evaluate — this usually takes a few minutes after you confirm.";
  }
  return "We’re auditing your pages for usability issues — this usually takes a few minutes. Findings will show up here as they land.";
}
